var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasBanner)?_c('div',{staticClass:"organization-profile-status-banner",class:_vm.bannerClass,attrs:{"role":"status"}},[_c('strong',[_vm._v(_vm._s(_vm.bannerLabel))]),_vm._v(" — "+_vm._s(_vm.bannerMessage)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }